// @flow
import { styled, withStyle } from 'mz-ui-kit'
import { getDeviceStyles } from '../../../utils'

export const EmptyDate = styled('div', {
  position: 'relative',
  flexShrink: 0,
  borderRadius: '100px',
  margin: 'auto auto 3px auto',
  width: '40px',
  height: '40px',
  maxWidth: '40px',
  maxHeight: '40px',
  minWidth: '40px',
  minHeight: '40px',
})

export const RegularDate = withStyle<
  typeof EmptyDate,
  {
    $today?: boolean,
    $past?: boolean,
    $selected?: boolean,
  }
>(EmptyDate, ({ $today, $past, $selected, $palette }) => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: `${$palette($selected ? 'primary' : 'transparent')}`,
  color: `${$palette($selected ? 'white' : 'text')}`,
  opacity: $past ? 0.4 : 1,
  pointerEvents: $past ? 'none' : 'inherit',
  boxShadow: $today ? `0 0 0 1px ${$palette('yellow')}` : 'none',
  fontSize: '14px',
  zIndex: $selected || $today ? 2 : 1,
  ...getDeviceStyles({
    cursor: 'pointer',
    transition: 'all 430ms cubic-bezier(0.165, 0.84, 0.44, 1)',
    ':hover': $selected
      ? {}
      : {
          backgroundColor: `${$palette('primary').lighten(40)}`,
        },
    ':active': {
      zIndex: 3,
      backgroundColor: `${$palette('primary')}`,
      color: `${$palette('white')}`,
    },
  }),
}))
